import Button from "../../../components/shared/Button";
import { Link } from "react-router-dom";

const NeedAdvice = () => {
  return (
    <div className="bg-no-repeat  bg-AdviceBg font-[Inter] bg-cover relative my-10 ">
      <div className="absolute inset-0 bg-[#000000CF] "></div>
      <div className="relative z-10">
        <div className=" transform p-2 sm:p-20 flex flex-col items-center gap-8 text-white text-center">
          <div className="h-1 w-14 bg-[#3b76db] sm:mb-5"></div>
          <h2 className="font-bold sm:text-6xl sm:leading-[0.7] text-2xl">
            Do You Need Quran Advice?
          </h2>
          <p className="text-sm sm:w-[50%] sm:mx-auto">
            Are you seeking guidance on your Quranic journey? <br /> Whether
            you're just starting out or looking to refine your recitation and
            memorization, our team at Maqrahaa ul Tanzeel is here to support
            you. <br /> We offer expert advice tailored to your individual
            needs—whether it’s understanding Tajweed, choosing the right course,
            or perfecting the art of Qira’at.
          </p>
          <p>
            Don't hesitate to reach out for personalized advice and take the
            next step in your journey to mastering the Quran.
          </p>
          <Link to={"https://wa.me/2348153783287"}>
            <Button
              btnBgColor={
                "bg-[#004C97] hover:bg-white hover:rounded-full sm:rounded-full hover:border hover:border-[#333333]"
              }
              btnColor={" text-white hover:text-[#333333]"}
              btnText={"Let's Talk"}
              padding={"px-7 py-2 transition-all  ease-in-out"}
            />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NeedAdvice;
